import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { Helmet } from "react-helmet-async";

//components
import { Loading } from "common/Loading";
import { ContentLayout } from "common/ContentLayout";
import { Groups } from "./Groups";

//actions
import { getGroups } from "feat/objects/actions";

export const GroupsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.groups.loading);

  useEffect(() => {
    dispatch(getGroups());
  }, [dispatch]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>Группы</title>
      </Helmet>

      <ContentLayout>
        <Groups />
      </ContentLayout>
    </>
  );
};
